import { Center } from '@chakra-ui/react';
import { useMemo } from 'react';

export const CONTROLS_SIZE = 32;
export const OPTIONS_SIZE = 60;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - CONTROLS_SIZE - OPTIONS_SIZE) * percent;
};

export const useLabelV2VersionListColumns = (totalWidth?: number) => {
  return useMemo(
    () => [
      {
        accessorKey: 'controls',
        header: <Center w={5}>#</Center>,
        accessory: true,
        size: CONTROLS_SIZE,
        sx: { pl: 1 },
      },
      {
        accessorKey: 'title',
        header: 'Title',
        sx: { pl: 0 },
        enableResizing: true,
        size: getColumnSize(0.25, totalWidth),
      },
      {
        accessorKey: 'song',
        header: 'Song',
        enableResizing: true,
        size: getColumnSize(0.25, totalWidth),
      },
      {
        accessorKey: 'date',
        header: 'Date',
        minSize: 88,
        size: getColumnSize(0.25, totalWidth),
        enableResizing: true,
      },
      {
        accessorKey: 'dataComp',
        header: 'Export ready',
        minSize: 84,
        size: getColumnSize(0.25, totalWidth),
        enableResizing: true,
      },
      {
        accessorKey: 'gap',
        size: 0,
      },
      {
        accessorKey: 'options',
        size: OPTIONS_SIZE,
        header: '',
        contextMenu: true,
      },
    ],
    [totalWidth]
  );
};
